module.exports = __webpack_public_path__ + "img/open-box.23b67d04.svg";